<ion-content>
  <app-global-page-header [title]="'P0003600.ensavoirplus' | translate">
    <div slot="end">
      <ion-button
        color="medium"
        fill="clear"
        shape="round"
        (click)="dismissModal()"
      >
        <i class="fa-solid fa-times"></i>
      </ion-button>
    </div>
  </app-global-page-header>

  <div class="p-4">
    <div>
      <div class="h4 mb-3">
        {{ 'P00058.filtrationHorlogeHiverEte' | translate }}
      </div>
      <p
        class="my-2 mb-4 color-medium"
        [innerHTML]="'P00058.filtrationHorlogeHiverEteText' | translate | nl2Br"
      ></p>
    </div>

    <div>
      <div class="h4 mb-3">
        {{ 'P00058.filtrationProgramme72H' | translate }}
      </div>
      <p
        class="my-2 mb-4 color-medium"
        [innerHTML]="'P00058.filtrationProgramme72HText' | translate | nl2Br"
      ></p>
    </div>

    <div>
      <div class="h4 mb-3">
        {{ 'P00058.filtrationBaignade' | translate }}
      </div>
      <p
        class="my-2 mb-4 color-medium"
        [innerHTML]="'P00058.filtrationBaignadeText' | translate | nl2Br"
      ></p>
    </div>
  </div>
</ion-content>
